import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

/**
 * Widget Echo — konverzációnkénti privát csatorna (Reverb / Pusher protokol).
 * Shadow DOM-tól függetlenül a host window-on fut.
 */
export function subscribeConversationChannel({
    reverb,
    broadcastAuthToken,
    botKey,
    conversationId,
    onStatusChanged,
    onAgentMessage,
}) {
    if (! reverb?.key || ! reverb?.host || ! broadcastAuthToken || ! conversationId) {
        return null;
    }

    window.Pusher = Pusher;

    const scheme = reverb.scheme === 'https' ? 'https' : 'http';
    const forceTLS = scheme === 'https';
    const port = Number(reverb.port) || (forceTLS ? 443 : 80);

    const echo = new Echo({
        broadcaster: 'reverb',
        key: reverb.key,
        wsHost: reverb.host,
        wsPort: port,
        wssPort: port,
        forceTLS,
        enabledTransports: ['ws', 'wss'],
        authEndpoint: reverb.auth_endpoint,
        auth: {
            headers: {
                'X-Bot-Key': botKey,
                Accept: 'application/json',
            },
        },
        authorizer: (channel) => ({
            authorize: (socketId, callback) => {
                fetch(reverb.auth_endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'X-Bot-Key': botKey,
                    },
                    body: JSON.stringify({
                        socket_id: socketId,
                        channel_name: channel.name,
                        broadcast_auth_token: broadcastAuthToken,
                    }),
                })
                    .then(async (response) => {
                        if (! response.ok) {
                            throw new Error(`Broadcast auth ${response.status}`);
                        }

                        return response.json();
                    })
                    .then((data) => callback(null, data))
                    .catch((error) => callback(error, null));
            },
        }),
    });

    const channel = echo.private(`conversation.${conversationId}`);

    channel.listen('.HandoverStatusChanged', (event) => {
        onStatusChanged?.(event);
    });

    channel.listen('.AgentMessageSent', (event) => {
        onAgentMessage?.(event);
    });

    return {
        echo,
        leave() {
            try {
                echo.leave(`conversation.${conversationId}`);
                echo.disconnect();
            } catch {
                // ignore
            }
        },
    };
}
